import { GetInvolvedFormCategory } from "@/models/get-involved";
import { formSlugs } from "./form-constants";


export const ImageConstants = {
  LOGO: "https://firebasestorage.googleapis.com/v0/b/assets-sq4a4/o/4xlogo.png?alt=media&token=65e1a07d-4e00-41cd-ab71-384a5bf4241e",
  CHAT_LOGO: "https://firebasestorage.googleapis.com/v0/b/assets-sq4a4/o/chat-logo.png?alt=media&token=f11f2f9b-df65-423c-b532-b56c42037689"
};

export const TokenConstants = {
  ACCESSIBLES: "accessibles",
  ACCESS_TOKEN: "access-token",
  SESSION_EXPIRED: "session_expired",

  REFRESH_TOKEN: "refresh_token",
  DECODED_TOKEN: "decoded_token",

  HEADER_PARTIAL_VALUE: "Bearer",
};

export const StatusCodeConstants = {
  STATUS_OK: 200,
  STATUS_FAILED: 400,
  STATUS_INTERNAL_SERVER_ERROR: 500,
  STATUS_TOKEN_EXPIRED: 401,
  STATUS_UNAUTHORIZED_REQUEST: 404,
  STATUS_SUCCESS: "success",
};

export const UserConstants = {
  USER_INFO: "user_info",
  USER_ID: "user-id",
};

export const userSignUpFormSteps = [
  {
    id: 1,
    title: "Email information",
    questionGuide: {
      title: "Email Address",
      body: "Your phone number has been verified. Please enter your email for your account.",
    },
    questions: [
      {
        id: 1,
        title: "Email Address",
        slug: "email",
        inputType: "INPUT_TEXT",
        options: [],
        value: "",
        placeholder: "elon@spacex.com",
        displayCondition: true,
        required: true,
      }, 
    ],
  },
  {
    id: 2,
    title: "Name information",
    questionGuide: {
      title: "Tell us about yourself",
      body: "Let's start with your name, please enter your first and last name below",
    },
    questions: [
      {
        id: 1,
        title: "First Name",
        slug: "firstName",
        inputType: "INPUT_TEXT",
        options: [],
        value: "",
        placeholder: "Elon",
        displayCondition: true,
        required: true,
      },
      {
        id: 2,
        title: "Last Name",
        slug: "lastName",
        inputType: "INPUT_TEXT",
        options: [],
        value: "",
        placeholder: "Musk",
        displayCondition: true,
        required: true,
      },
    ],
  },
  {
    id: 3,
    title: "Exploring Motivation",
    questionGuide: {
      title: "What brings you to C-Tribe?",
      body: "Select all that apply",
    },
    questions: [
      {
        id: 1,
        title: "Motivation Question",
        slug: "motivations",
        inputType: "INPUT_CHECKBOX",
        options: [
          {
            id: 0,
            title: "Find new business/investment opportunities",
            selected: false,
          },
          { id: 1, title: "Seek employment/contract work", selected: false },
          { id: 2, title: "Hire talented people", selected: false },
          { id: 3, title: "Socialization and partying", selected: false },
          { id: 4, title: "Networking opportunities", selected: false },
          {
            id: 5,
            title: "Supporting the innovation and creative ecosystem",
            selected: false,
          },
        ],
        value: "",
        placeholder: "Choose your answer",
        displayCondition: true,
        required: true,
      },
    ],
  },
  {
    id: 4,
    title: "Interests information",
    questionGuide: {
      title: "What are your interests?",
      body: "Select all that apply",
    },
    questions: [
      {
        id: 1,
        title: "Interests",
        slug: "tags",
        inputType: "INPUT_CHECKBOX",
        options: [
          { id: 0, title: "Technology", selected: false },
          { id: 1, title: "Gaming", selected: false },
          { id: 3, title: "Music", selected: false },
          { id: 4, title: "Fashion", selected: false },
          { id: 6, title: "Culture", selected: false },
          { id: 7, title: "Film", selected: false },
        ],
        value: "",
        placeholder: "Choose your answer",
        displayCondition: true,
        required: true,
      },
    ],
  },
];

export const industryOptions = [
  "Agriculture",
  "Big Data",
  "Blockchain Technology",
  "Consulting",
  "Cryptocurrency",
  "E-Commerce",
  "Education",
  "Energy, Environment, & Cleantech",
  "Entertainment, Media & Art",
  "Finance & Fintech",
  "Food & Beverage",
  "Gaming",
  "Healthcare & Biotechnology",
  "Human Resources",
  "Import/Export",
  "Information/Technology, SaaS",
  "Marketing, Branding & Advertising",
  "Metaverse",
  "Mobile & Wireless",
  "Natural Resources",
  "Real Estate",
  "Retail & Fashion",
  "Social Enterprise",
  "Social Media/Social Network",
  "Sports, Lifestyle, Fitness",
  "Transportation & Logistics",
  "Other",
] as const;

export const secondaryIndustries = [
  "Agriculture",
  "Big Data",
  "Blockchain Technology",
  "Consulting",
  "Cryptocurrency",
  "E-Commerce",
  "Education",
  "Energy, Environment, & Cleantech",
  "Entertainment, Media & Art",
  "Finance & Fintech",
  "Food & Beverage",
  "Gaming",
  "Healthcare & Biotechnology",
  "Human Resources",
  "Import/Export",
  "Information/Technology, SaaS",
  "Marketing, Branding & Advertising",
  "Metaverse",
  "Mobile & Wireless",
  "Natural Resources",
  "Real Estate",
  "Retail & Fashion",
  "Social Enterprise",
  "Social Media/Social Network",
  "Sports, Lifestyle, Fitness",
  "Transportation & Logistics",
  "Other",
] as const;

export const genderIdentities = [
  "Woman",
  "Man",
  "Transgender",
  "Gender Neutral",
  "Non-Binary",
  "Agender",
  "Pangender",
  "Genderqueer",
  "Two-Spirit",
  "Third Gender",
  "Other",
] as const;

export const profileThemeOptions = [
  "#FFEFD0-#E09DDC-#8985D5-#4891DC-#3C4051",
  "#333E48-#2F3068-#4891DC-#FFF1D0",
  "#333E48-#7A428D-#F05283-#FFF1D0",
  "#333E48-#00594F-#97CD78-#FFF1D0",
  "#333E48-#FF983A-#FFC63E-#FFF1D0",
  "#333E48-#EF435E-#FFDB76-#FFF1D0",
  "#333E48-#7A428D"
] as const;

export const ageRanges: string[] = [
  "17 and below",
  "18-24",
  "25-34",
  "35-44",
  "45-54",
  "55-64",
  "65 and over",
];

export const marketPlaceIndustry: string[] = [ 
  "Accounting",
  "Airline Aviation",
  "Alternative Dispute Resolution",
  "Alternative Medicine",
  "Animation",
  "Apparel & Fashion",
  "Architecture",
"Arts & Crafts",
"Automotive",
"Aviation Aerospace",
"Banking",
"Biotechnology",
"Broadcast Media",
"Building Materials",
"Business Supplies",
"Capital Markets",
"Chemicals",
"Civic & Social Organization",
"Civil Engineering",
"Commercial Real Estate Communications",
"Computer Security",
"Computer Games",
"Computer Hardware",
"Computer Networking",
"Computer Software",
"Construction",
"Consumer Electronics",
"Consumer Goods",
"Consumer Services",
"Cosmetics",
"Dairy",
"Defense",
"Design",
"Education",
"E-Learning",
"Electrical Electronic Manufacturing",
"Entertainment",
"Environmental Services",
"Events Services",
"Executive Office",
"Facilities Services Family Services",
"Farming",
"Financial Services",
"Fine Art",
"Fishery",
"Food & Beverages",
"Food Production",
"Fundraising",
"Furniture",
"Gambling & Casinos",
"Glass, Ceramics & Concrete",
"Government Administration",
"Government Relations",
"Graphic Design",
"Health, Wellness & Fitness",
"Higher Education",
"Hospital & Health Care",
"Hospitality",
"Human Resources",
"Import & Export",
"Industrial Automation Industrial Engineering",
"Information Services",
"Information Technology",
"Insurance",
"International Affairs",
"International Trade",
"Internet",
"Investment Banking",
"Investment Management",
"Judiciary",
"Law Enforcement",
"Law Practice",
"Legal Services",
"Legislative Office",
"Leisure, Travel & Tourism",
"Libraries",
"Logistics & Supply Chain",
"Luxury Goods",
"Machinery",
"Management Consulting",
"Maritime",
"Market Research",
"Marketing & Advertising",
"Mechanical Engineering",
"Media Production",
"Medical Devices",
"Medical Practice",
"Mental Health Care",
"Military",
"Mining & Metals",
"Motion Pictures & Film",
"Museums & Institutions",
"Music",
"Nanotechnology",
"Newspapers",
"Non-Profit",
"Oil & Energy",
"Online Media",
"Outsourcing/Offshoring",
"Package/Freight Delivery",
"Packaging & Containers",
"Paper & Forest Products",
"Performing Arts",
"Pharmaceuticals",
"Philanthropy",
"Photography",
"Plastics",
"Political Organization",
"Printing Private Equity",
"Professional Training",
"Program Development",
"Public Policy",
"Public Relations",
"Public Safety",
"Publishing",
"Railroad Manufacture",
"Ranching",
"Real Estate",
"Recreational",
"Religious Institutions",
"Renewables & Environment",
"Research",
"Restaurants",
"Retail",
"Security",
"Semiconductors",
"Shipbuilding Space",
"Sporting Goods",
"Sports",
"Staffing & Recruiting",
"Supermarkets",
"Telecommunications",
"Textiles",
"Think Tanks",
"Tobacco",
"Translation",
"Transportation",
"Utilities",
"Venture Capital",
"Veterinary",
"Warehousing",
"Wholesale",
"Wine & Spirits",
"Wireless",
"Writing",
];

const asianOptions = [
  { value: "East Asian", label: "East Asian" },
  { value: "South Asian", label: "South Asian" },
  { value: "Southeast Asian", label: "Southeast Asian" },
];

const NativeIndAborOptions = [
  { value: "First Nations", label: "First Nations" },
  { value: "Métis", label: "Métis" },
  { value: "Inuit", label: "Inuit" },
];

const MiddleArabOptions = [
  { value: "Middle Eastern", label: "Middle Eastern" },
  { value: "Arab", label: "Arab" },
];

const LatinAmericanHispanicOptions = [
  { value: "Latin American", label: "Latin American" },
  { value: "Hispanic", label: "Hispanic" },
];
const BlackAfricanCaribeanOptions = [
  { value: "Black", label: "Black" },
  { value: "North African", label: "North African" },
  { value: "Central African", label: "Central African" },
  { value: "South African", label: "South African" },
  { value: "East African", label: "East African" },
  { value: "West African", label: "West African" },
];

const WhiteEuropeanOptions = [
  { value: "White", label: "White" },
  { value: "North European", label: "North European" },
  { value: "South European", label: "South European" },
  { value: "East European", label: "East European" },
  { value: "West European", label: "West European" },
];
const OtherOptions = [{ value: "Other", label: "Other" }];

export const verticalOptions = [
  "Tech",
  "Gaming",
  "Fashion",
  "Music",
  "Culture",
  "Film",
] as const;

export interface GroupOption {
  value: string;
  label: string;
}
export interface GroupedOption {
  label: string;
  options: GroupOption[];
}

export const RaceEthnicityOptions: GroupedOption[] = [
  {
    label: "Asian",
    options: asianOptions,
  },
  {
    label: "Native/Indigenous/Aboriginal",
    options: NativeIndAborOptions,
  },
  {
    label: "Middle Eastern/Arab",
    options: MiddleArabOptions,
  },
  {
    label: "Latin American/Hispanic",
    options: LatinAmericanHispanicOptions,
  },
  {
    label: "Black/African/Caribbean",
    options: BlackAfricanCaribeanOptions,
  },
  {
    label: "White/European",
    options: WhiteEuropeanOptions,
  },
  {
    label: "Other",
    options: OtherOptions,
  },
] as const;

export const nonProtectedRoutes = ["/email-redirect", "/linkedin-redirect", "/unsubscribe", "/annual-report", "/passes/buy", "/donate", "/form", "/pay/designer", "/confirm/model"];

export const receiveNotificationOptions = ["Select", "All Users"] as const;

export enum FunctionUrl {
  GET_FAQS = "https://getfaqs-5kuwlgfdha-uc.a.run.app/",
}

export const formCategories: GetInvolvedFormCategory[] = [
  { label: "General", value: "general", bulletColor: "#E09DDC" },
  { label: "Tech", value: "tech", bulletColor: "#97CD78" },
  { label: "Gaming", value: "gaming", bulletColor: "#4891DC" },
  { label: "Fashion", value: "fashion", bulletColor: "#FFC63E" },
  { label: "Music", value: "music", bulletColor: "#F05283" },
] as const;

// export const passesData: Pass[] = [
//   {
//     id: "",
//     title: "diversity-pass",
//     productId: "",
//     priceId: "",
//     description:
//       "Gain valuable insights and connect with like-minded  innovative and creative people during all conference sessions, workshops & masterclasses , iconic performances, unparalleled networking opportunities, showcases, and beyond. Diversity Passes are set aside and provided for free to individuals that embrace diversity and/or may not have the means to afford a delegate pass.",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20Diversity%20Pass%20-%20landscape.jpg?alt=media&token=ed515457-1e77-4c61-8c27-49d56fcc9008",
//     programHighlights: [
//       "Gain valuable insights and knowledge from the best in the innovative and creative industries.",
//       "Benefit from a diverse range of programming converging tech, fashion, gaming, culture and more.",
//       "Network with industry leaders and expand your professional connections to help advance your endeavours",
//       "C-Afrofuturism events and exhibits",
//       "Esports tournament & Game Jams",
//       "Fashion shows & showcases",
//       "Exclusive Film showcases",
//       "Pitch Competitions (must register separately to pitch)",
//       "Networking Meet Ups",
//       "Parties & after socials",
//       "Access to best hotel rates",
//     ],
//     access: [
//       "Opening & closing reception",
//       "Conference Main Stage",
//       "Workshops & Masterclasses",
//       "Music Main Stage and MusicVerse Series",
//       "C-Tribe Village Expo Floor",
//       "Recruitment opportunities",
//     ],
//   },
//   {
//     id: "",
//     title: "tribe-pass",
//     productId: "prod_Pc5QauePkvEhvD",
//     priceId: "price_1OmrFqKYWph1lIbDwOkrvZZC",
//     description:
//       "Unlock general access C-Tribe's offerings, including our groundbreaking conference sessions, workshops & masterclasses , iconic performances, unparalleled networking opportunities, showcases, and beyond.",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20Tribe%20Pass%20-%20landscape.jpg?alt=media&token=cc890dbd-5166-4378-91ea-0791af4ce851",
//     programHighlights: [
//       "Gain valuable insights and knowledge from the best in the innovative and creative industries.",
//       "Benefit from a diverse range of programming converging tech, fashion, gaming, culture and more.",
//       "Network with industry leaders and expand your professional connections to help advance your endeavors.",
//       "C-Afrofuturism events and exhibits",
//       "Esports tournament & Game Jams",
//       "Fashion shows & showcases",
//       "Exclusive Film showcases",
//       "Pitch Competitions",
//       "Networking Meet Ups",
//       "Parties & after socials",
//       "Access to best hotel rates",
//     ],
//     access: [
//       "Opening & closing reception",
//       "Conference Main Stage",
//       "Workshops & Masterclasses",
//       "Music Main Stage and MusicVerse Series",
//       "C-Tribe Village Expo Floor",
//       "Recruitment opportunities",
//     ],
//   },
//   {
//     id: "",
//     title: "vip-pass",
//     productId: "prod_Pc5QLUuCk6C8Li",
//     priceId: "price_1OmrFlKYWph1lIbDLugwSvQA",
//     description:
//       "Unlock the entirety of C-Tribe's offerings, as a VIP including our groundbreaking conference sessions, workshops & masterclasses, iconic performances, unparalleled networking opportunities, showcases, and beyond.",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20VIP%20Pass%20-%20landscape.jpg?alt=media&token=a6e28bf5-c159-4302-86f3-6a331fc70a59",
//     programHighlights: [
//       "Take part in the conversations on how to shape the future of innovative and creative industries.",
//       "Get back-stage and meet-and-greet access to a diverse range of programming converging tech, fashion, gaming, culture and more.",
//       "Arrive in style with VIP entry, by pass all other lines, access reserved seating, and exclusive VIP lounges.",
//       "Early access to marketplace",
//       "Reserved seating (upon request) at showcases, keynotes and special events",
//       "Shuttles between venues",
//       "Complementary food and beverages at all events",
//       "VIP gift bags at special events",
//       "Exclusive networking events",
//     ],
//     access: [
//       "Includes everything in the Tribe Pass",
//       "Backstage meet-and-greets with speakers, artists and special guests",
//       "VIP Dinners access",
//       "VIP access, by passing lines, for immediate access to all events",
//     ],
//   },
//   {
//     id: "",
//     title: "executive-pass",
//     productId: "prod_Pc5QIyKk5l9n3L",
//     priceId: "price_1OmrFgKYWph1lIbD24kQHrry",
//     description:
//       "Join our exclusive networking event and connect with executives, tenured VCs, moguls in the innovative and creative sectors to expand your network in a expertly curated way. Discover new opportunities to advance your career with the best and brightest in industry. ",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20Executive%20Pass%20-%20landscape.jpg?alt=media&token=46042563-7ba8-4146-bb5b-199d09a220d0",
//     programHighlights: [
//       "Access the Executive Welcome Receptions and bespoke networking experience curated by a dedicated C-Tribe concierge.",
//       "Received personalized recruitment and/or investment opportunities.",
//       "Invites to recommended partner events.",
//       "Reserved seating (upon request) at showcases, keynotes and special events.",
//       "Shuttles between venues",
//       "Complementary food and beverages at all events",
//       "VIP gift bags at special events",
//       "Exclusive networking events",
//     ],
//     access: [
//       "Includes everything in the VIP Pass",
//       "Executive Welcome Reception",
//       "Recommended partner events",
//       "Recruitment & investor recommendations",
//     ],
//   },

//   {
//     id: "",
//     title: "gaming-pass",
//     productId: "prod_Pc5QApFLGfzMia",
//     priceId: "price_1OmrFUKYWph1lIbDajnG4j8m",
//     description:
//       "The C-Tribe x Gaming Pass gives you access to a culture of exploration and discovery, professional development, and learning opportunities via our game jams, pitch quests, mentor & publisher zones, hands-on workshops and more. Gain primary access to all gaming events and secondary access to film, tech, culture, fashion and music.",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20Gaming%20Pass%20-%20landscape.jpg?alt=media&token=bf5bad04-07a5-493f-8f51-97a3c86e6915",
//     programHighlights: [
//       "Get primary access across all C-Tribe x Gaming events: PlayTest Zone, Game Jams, Esports World, Workshops & Masterclasses and more",
//       "Gain secondary access to a diverse range of programming converging tech, fashion, music, film, culture and more",
//       "Network with industry leaders and expand your friendships and professional connections to help advance your endeavours",
//       "Networking and meet ups",
//       "Parties and after socials",
//       "Access to best hotel rates",
//       "Food pass and beverage pass at all C-Tribe x Gaming events",
//     ],
//     access: [
//       "Opening and closing reception",
//       "Conference Main Stage",
//       "C-Tribe Village Expo Floor",
//       "Recruitment opportunities",
//     ],
//   },
//   {
//     id: "",
//     title: "music-pass",
//     productId: "prod_Pc5QeZpZgjRsDV",
//     priceId: "price_1OmrFNKYWph1lIbDF4SFJJ0l",
//     description:
//       "The C-Tribe x Music Pass gives you primary access to our iconic music showcases,  main stage festivals, professional development, and learning opportunities. Gain primary access to all music events and secondary access to film, tech, culture, fashion and gaming.",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20Music%20Pass%20-%20landscape.jpg?alt=media&token=8d56297d-ba3c-4d6c-a59e-9b902dcc7430",
//     programHighlights: [
//       "Get primary access across all C-Tribe x Music events: MusicVerse Series, Music Main Stage, Workshops & Masterclasses, Music Agent's Zone and more.",
//       "Gain secondary access to a diverse range of programming converging tech, fashion, gaming, tech, culture and more",
//       "Network with industry leaders and expand your friendships and professional connections to help advance your endeavours",
//       "Networking and meet ups",
//       "Parties and after socials",
//       "Access to best hotel rates",
//       "Food pass and beverage pass at all C-Tribe x Music events",
//     ],
//     access: [
//       "Opening and closing reception",
//       "Conference Main Stage",
//       "C-Tribe Village Expo Floor",
//       "Recruitment opportunities",
//     ],
//   },
//   {
//     id: "",
//     title: "culture-pass",
//     productId: "prod_Pc5QBifjsKk2Om",
//     priceId: "price_1OmrFCKYWph1lIbDcuwLqaXI",
//     description:
//       "The C-Tribe x Culture Pass gives you primary access to our culturally-inspired celebrations, networking events, and professional development and learning opportunities. Gain primary access to all culture events and secondary access to film, tech, culture, music and gaming. ",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20Culture%20Pass%20-%20landscape.jpg?alt=media&token=bb9acd31-b057-4282-b1e8-27e73dfc4d12",
//     programHighlights: [
//       "Get primary access across all C-Tribe x Culture events: Workshops & Masterclasses, Afro-Latin Nights, Tokyo Nights, C-Afrofuturism Conference  and more",
//       "Gain secondary access to a diverse range of programming converging tech, fashion, music, film, gaming and more",
//       "Network with industry leaders and expand your friendships and professional connections to help advance your endeavours",
//       "Networking and meet ups",
//       "Parties and after socials",
//       "Access to best hotel rates",
//       "Food pass and beverage pass at all C-Tribe x Culture events",
//     ],
//     access: [
//       "Opening and closing reception",
//       "Conference Main Stage",
//       "C-Tribe Village Expo Floor",
//       "Recruitment opportunities",
//     ],
//   },
//   {
//     id: "",
//     title: "fashion-pass",
//     productId: "prod_Pc5QZM0iPqMVGu",
//     priceId: "price_1OmrFJKYWph1lIbDTOViA9Wq",
//     description:
//       "The C-Tribe x Fashion Pass gives you primary access to our fashion shows, iconic showcases, Buyer Zone, networking events professional development, and learning opportunities. Gain primary access to all fashion events and secondary access to film, tech, culture, music and gaming.",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20Fashion%20Pass%20-%20landscape.jpg?alt=media&token=6b8d1beb-bbca-4fc5-907e-d3fd5f1484f7",
//     programHighlights: [
//       "Get primary access across all C-Tribe x Fashion events: Fashion Show I & II, Marketplace, Workshops & Masterclasses  and more",
//       "Gain secondary access to a diverse range of programming converging tech, culture, music, film, gaming and more",
//       "Network with industry leaders and expand your friendships and professional connections to help advance your endeavours",
//       "Networking and meet ups",
//       "Parties and after socials",
//       "Access to best hotel rates",
//       "Food pass and beverage pass at all C-Tribe x Fashion events",
//     ],
//     access: [
//       "Opening and closing reception",
//       "Conference Main Stage",
//       "C-Tribe Village Expo Floor",
//       "Recruitment opportunities",
//     ],
//   },
//   {
//     id: "",
//     title: "tech-pass",
//     productId: "prod_Pc5QOjBXrYpqS2",
//     priceId: "price_1OmrFaKYWph1lIbDmixaRNnJ",
//     description:
//       "The C-Tribe x Tech Pass gives you access to unparalleled  discovery, professional development, and learning opportunities via our groundbreaking sessions, mentor & investor zones, hands-on workshops and more. Gain primary access to all tech events and secondary access to film, gaming, culture, fashion and music.",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20Tech%20Pass%20-%20landscape.jpg?alt=media&token=17d2a987-0ad0-4fd3-a6a2-d4ba09ba4885",
//     programHighlights: [
//       "Get primary access across all C-Tribe x Tech events: Workshops & Masterclasses, Pitch Competitions, Conference Main Stage and more",
//       "Gain secondary access to a diverse range of programming converging tech, fashion, music, film, gaming and more",
//       "Network with industry leaders and expand your friendships and professional connections to help advance your endeavours",
//       "Networking and meet ups",
//       "Parties and after socials",
//       "Access to best hotel rates",
//       "Food pass and beverage pass at all C-Tribe x Tech events",
//     ],
//     access: [
//       "Opening and closing reception",
//       "Conference Main Stage",
//       "C-Tribe Village Expo Floor",
//       "Recruitment opportunities",
//     ],
//   },
//   {
//     id: "",
//     title: "single-event-pass",
//     productId: "prod_QBZkGSfvYiJyLI",
//     priceId: "price_1PLCajKYWph1lIbD6bjlcN1M",
//     description:
//       "Choose your adventure with single event access to any C-Tribe event in any vertical. Whether it's a Film, Culture, Tech, Music, Fashion, or Gaming event, you get to pick one event and fully immerse yourself in the experience.",
//     image: "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20Single%20Event%20Pass%20-%20landscape.jpg?alt=media&token=980dceb4-aae7-4706-a2af-14f4bd06ac6c",
//     programHighlights: [],
//     access: [],
//   }
// ];

// export const TechLuncheonPasses: Pass[] = [
//     {
//       id: "",
//       title: "tech-luncheon-general-admission-pass",
//       productId: "",
//       priceId: "",
//       isTechLuncheon: true,
//       techLuncheonDescription: [
//         "At the C-Tribe x Tech Exec Luncheon, we invite you to forge powerful connections with like-minded industry leaders, enabling you to drive the evolution of technology forward and create lasting impact. Together, we'll navigate the ever-changing tech landscape, explore emerging opportunities, and set the stage for a brighter future.",
//         "Nicholas Brathwaite has over 25 years of experience developing technology and building technology-oriented businesses. Before Celesta, Nicholas was also co-founder and partner of private equity firm Riverwood Capital, and from 1996 to 2007, he served as the CTO at Flex, overseeing the launch and growth of several of Flex’s largest business units, including an innovative push into product development (open to all General Attendees).",
//       ],
//       image: "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20Tech%20Luncheon%20VIP%20Pass.png?alt=media&token=97fd22b0-794d-403b-b924-5ff698b9b2ba",
//       programHighlights: [],
//       access: [],
//       description: "",
//       additionalInfo: [
//         {
//           key: "ABOUT THE FIRESIDE CHAT WITH NICHOLAS BRATHWAITE",
//           info: [
//             "Deep tech. It’s a flashy term used too often without a good understanding of the actual meaning. However, in the coming decade, this term will have greater and greater impact on our society and the environment. In fact, deep tech has already made a tremendous amount of impact on our everyday lives.",
//             "Simply defined, the term refers to technology that, because of the extreme difficulty involved, has a longer runway to commercial application but has the potential to disrupt existing sectors or create entirely new ones. Regardless of the investment involved, from computing to biotech, transportation and AI, deep tech has the potential to provide solutions to some of the most challenging problems the world faces. Working with such advanced technology can often seem unachievable for a commercial venture, especially given the long horizons and limited resources of startups. In this C-Tribe x Tech Luncheon, we will explore how startups successfully innovate with deep tech and how investors are scaling their impact with deep tech investments.",
//           ],
//         },
//         {
//           key: "PROGRAMMING ACCESS",
//           info: [
//             "General Admission passes allow in-person and virtual admittance to the C-Tribe x Tech Exec Luncheon, but it doesn't include access to the VIP Dinner.",
//           ],
//         },
//       ],
//     },
//     {
//       id: "",
//       title: "tech-luncheon-vip-pass",
//       productId: "",
//       priceId: "",
//       isTechLuncheon: true,
//       description: "",
//       programHighlights: [],
//       image: "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20Tech%20Luncheon%20VIP%20Pass.png?alt=media&token=97fd22b0-794d-403b-b924-5ff698b9b2ba",
//       access: [],
//       techLuncheonDescription: [
//         "At the C-Tribe x Tech Exec Luncheon, we invite you to forge powerful connections with like-minded industry leaders, enabling you to drive the evolution of technology forward and create lasting impact. Together, we'll navigate the ever-changing tech landscape, explore emerging opportunities, and set the stage for a brighter future.",
//         "Nicholas Brathwaite has over 25 years of experience developing technology and building technology-oriented businesses. Before Celesta, Nicholas was also co-founder and partner of private equity firm Riverwood Capital, and from 1996 to 2007, he served as the CTO at Flex, overseeing the launch and growth of several of Flex’s largest business units, including an innovative push into product development (open to all General Attendees).",
//       ],
//       additionalInfo: [
//         {
//           key: "ABOUT THE FIRESIDE CHAT WITH NICHOLAS BRATHWAITE",
//           info: [
//             "Deep tech. It’s a flashy term used too often without a good understanding of the actual meaning. However, in the coming decade, this term will have greater and greater impact on our society and the environment. In fact, deep tech has already made a tremendous amount of impact on our everyday lives.",
//             "Simply defined, the term refers to technology that, because of the extreme difficulty involved, has a longer runway to commercial application but has the potential to disrupt existing sectors or create entirely new ones. Regardless of the investment involved, from computing to biotech, transportation and AI, deep tech has the potential to provide solutions to some of the most challenging problems the world faces. Working with such advanced technology can often seem unachievable for a commercial venture, especially given the long horizons and limited resources of startups. In this C-Tribe x Tech Luncheon, we will explore how startups successfully innovate with deep tech and how investors are scaling their impact with deep tech investments.",
//           ],
//         },
//         {
//           key: "PROGRAMMING ACCESS",
//           info: [
//             "VIP passes allow in-person and virtual admittance to the C-Tribe x Tech Exec Luncheon and includes access to the VIP Dinner.",
//           ],
//         },
//       ],
//       isVipDinner: true,
//     },
//   ];

// export const partnerPasses: Pass[] = [
//   {
//     id: "",
//     title: "friend-partner",
//     displayName: "Friend",
//     description: "",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20VIP%20Pass%20-%20landscape.jpg?alt=media&token=a6e28bf5-c159-4302-86f3-6a331fc70a59",
//     programHighlights: [],
//     access: [],
//     productId: "",
//     priceId: "",
//     additionalInfo: [
//       {
//         key: "Features",
//         info: [
//           "10' x 8' booth space",
//           "One skirted table with 2 folding chairs",
//           "1x social media promotion n",
//           "Featured Exhibitor Listing",
//         ],
//       },
//     ],
//     type: "partner",
//   },
//   {
//     id: "",
//     title: "friend-plus-partner",
//     displayName: "Friend Plus",
//     description: "",
//     image:
//       "https://firebasestorage.googleapis.com/v0/b/project-brain-f7594.appspot.com/o/passes%2FC-Tribe%20Festival%20-%20VIP%20Pass%20-%20landscape.jpg?alt=media&token=a6e28bf5-c159-4302-86f3-6a331fc70a59",
//     programHighlights: [],
//     access: [],
//     productId: "",
//     priceId: "",
//     additionalInfo: [
//       {
//         key: "Features",
//         info: [
//           "20' x 20' booth, premium booth location",
//           "Two skirted tables with 2 folding chairs",
//           "Featured Exhibitor Promotion or Email Event Marketing",
//           "3x social media promotion",
//           "Featured Exhibitor Online Listing",
//         ],
//       },
//     ],
//     type: "partner",
//   },
// ];

export const allowedExtendedInputsForForms = [
  formSlugs.fashionModel,
  formSlugs.influencer
]

export const extendedHeaders = {
  modelled: "Have you ever modelled for C-Tribe before?",
  attended: "Have you ever attended a C-Tribe casting before?",
  lorem: "Are you available to attend the Opening Reception on Wednesday, August 11th at 8:30 PM?",
  attachment: "attachment"
}
